// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IIsObject = (item: any) => boolean;

interface IObject {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

type IDeepMerge = (target: IObject, ...sources: IObject[]) => IObject;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObject: IIsObject = (item: any): boolean => {
    return item === Object(item) && !Array.isArray(item);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const copyPropertiesExcludeNullsAndGetters = (target: any, source: any) => {
    Object.keys(source).forEach((key) => {
        const keyInTarget = Object.getOwnPropertyDescriptor(target, key);
        if (
            source[key] !== null &&
            source[key] !== undefined &&
            (!keyInTarget || (keyInTarget && keyInTarget.configurable))
        ) {
            target[key] = source[key];
        }
    });
};

export const deepMerge: IDeepMerge = (target: IObject, ...sources: IObject[]): IObject => {
    if (!sources.length) {
        return target;
    }

    const result: IObject = target;

    if (isObject(result)) {
        sources.forEach((source) => {
            if (isObject(source)) {
                Object.keys(source).forEach((key) => {
                    if (source.hasOwnProperty(key)) {
                        if (isObject(source[key])) {
                            if (!result[key] || !isObject(result[key])) {
                                result[key] = {};
                            }
                            deepMerge(result[key], source[key]);
                        } else {
                            if (Array.isArray(result[key]) && Array.isArray(source[key])) {
                                result[key] = Array.from(new Set(result[key].concat(source[key])));
                            } else {
                                result[key] = source[key];
                            }
                        }
                    }
                });
            }
        });
    }

    return result;
};
